import { render, staticRenderFns } from "./VehicleForm.vue?vue&type=template&id=384ee13e&scoped=true&"
import script from "./VehicleForm.vue?vue&type=script&lang=ts&"
export * from "./VehicleForm.vue?vue&type=script&lang=ts&"
import style0 from "./VehicleForm.vue?vue&type=style&index=0&id=384ee13e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384ee13e",
  null
  
)

export default component.exports